import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"
import DataTableEns from "./DataTableEns"
import GenerationAutoSem from "./GenerationAutoSem"
import ParametreAutoSem from "./ParametreAutoSem"

const SchedulesEnseignants = props => {
  const [section, setSection] = useState(0)
  const [semestre, setSemestre] = useState([
    { id: 1, label: "Emploi enseignant Semestre 1", section: 0 },
    { id: 2, label: "Emploi enseignant Semestre 2", section: 1 },
    { id: 3, label: "Génération emploi automatique", section: 2 },
    { id: 4, label: "Paramètre des seances", section: 3 },
  ])
  const [add, setAdd] = useState(0);
  const [cloture, setCloture] = useState(0);
  useEffect(async () => {
    var cloture_annee = JSON.parse(localStorage.getItem("cloture"));
    setCloture(cloture_annee)
    const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
    const typeArticleSubMenu = userAuth.find(user =>
      user.sous_menu.some(subMenu => subMenu.sous_menu === "Emploi enseignant")
    );
    setAdd(typeArticleSubMenu.sous_menu[0].add)
  }, [])
  const renderBlock = (section) => {
    for (let i = 0; i < semestre.length; i++) {
      if (section === i) {
        if (i === 2 && section === 2) {
          return <GenerationAutoSem />;
        }
        if (i === 3 && section === 3) {
          return <ParametreAutoSem />;
        }
        return <DataTableEns semestre={semestre[i].id} />;
      }
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Emploi Enseignant | Cresus </title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              {semestre.map((element, index) => (
                <NavItem key={index}>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: section === element.section,
                    })}
                    onClick={() => {
                      setSection(element.section)
                    }}
                  >
                    <span className="d-none d-sm-block">{element.label}</span>
                  </NavLink>
                </NavItem>
              ))}

            </Nav>
            <Card>
              <CardBody>{renderBlock(section)}</CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(SchedulesEnseignants)
